export enum FeatureFlag {
  ACCOUNT_HOOKS = 'account_hooks',
  ARCHIVE_PROJECT = 'archive_project',
  ASSET_MANAGEMENT = 'asset_management_accounting',
  AUTOMATIONS = 'automations',
  BUDGET_BUILDER = 'budget_builder',
  COMPLETED_AT_FOR_PREDECESSORS = 'completed_at_for_predecessors',
  DISPOSITIONS_TAB = 'dispositions_tab',
  EMAIL_ENGAGEMENTS = 'email_engagements',
  ETHAN = 'ethan',
  FACILITY_REPORTS = 'facility_reports',
  KEY_DATE_LINKING = 'key_date_linked_fields',
  LOAN_QUOTES = 'loan_quotes',
  PIPELINE_MAP = 'pipeline_map',
  POSTAL_LEASE_ABSTRACT = 'postal_lease_abstract',
  REPORTS_TAB = 'reports_tab',
  SORT_VISUALIZATION_KEYS = 'sort_visualization_keys',
  SUMMARY_FORMULAS = 'summary_formulas',
  TABLE_REPORT_VISUALIZATION = 'table_report_visualization',
  TASKS_CUSTOM_FIELDS = 'tasks_custom_fields',
  TASKS_LIST_BASELINES = 'task_list_baselines',
  ZERO_HANDLING = 'zero_handling',
  INVERSE_RELATIONSHIP = 'inverse_relationship',
  MICROSOFT_PROJECT = 'microsoft_project',
  NEW_LEASES_TAB = 'new_leases_tab',
  DRAFT_TASK_LIST = 'task_list_drafts',
  GROUP_IMPORTS = 'group_imports',
  NEW_NAVIGATION = 'new_navigation',
  INFINITE_SCROLL_TASKS = 'infinite_scroll_tasks',
  TASK_UPLOAD_DESTINATION_FOLDER = 'task_upload_destination_folder',
  MULTIPLE_SSO = 'multiple_sso',
  AGGREGATED_TASKS_SAVED_VIEWS_ORDERING = 'aggregated_tasks_saved_views_ordering',
  POSTGIS_LOCATION_FILTERS = 'postgis_location_filters',
  NEW_TASK_PERMISSIONS = 'new_task_permissions',
  INFINITE_SCROLL = 'infinite_scroll',
  TASK_ROW_NUMBER_CODES = 'task_row_number_codes',
  APPROVALS = 'approvals',
  ENFORCE_REQUIRED_FIELDS = 'enforce_required_fields',
}
